export default [
	 {  // 【实验室管理】-【Banner】
		path: 'website/laboratory/banner',
		name: 'm_laboratory_banner',
		meta: {
			title: '实验室Banner'
		},
		component: () => import('@/pages/website/laboratory/laboratory_banner')
	 },
     {  // 【实验室管理】-【简介】
		path: 'website/laboratory/brief',
		name: 'm_laboratory_brief',
		meta: {
			title: '实验室介绍'
		},
		 props: {languageType:1},
		component: () => import('@/pages/website/laboratory/laboratory_brief')
	},
	{  // 【实验室管理】-【简介】-英文
		path: 'website/laboratory/brief/en',
		name: 'm_laboratory_brief_en',
		meta: {
			title: '实验室介绍'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/laboratory/laboratory_brief')
	},
	{  // 【实验室管理】-【科研动态】
		path: 'website/laboratory/research/trends',
		name: 'm_research_trends',
		meta: {
			title: '科研动态'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/laboratory/research_trends_list')
	},
	{  // 【实验室管理】-【科研动态】-英文
		path: 'website/laboratory/research/trends/en',
		name: 'm_research_trends_en',
		meta: {
			title: '科研动态'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/laboratory/research_trends_list')
	},
	{  // 【实验室管理】-【学术活动】
		path: 'website/laboratory/academic/activity',
		name: 'm_academic_activity',
		meta: {
			title: '学术活动'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/laboratory/academic_activity_list')
	},
	{  // 【实验室管理】-【学术活动】-英文
		path: 'website/laboratory/academic/activity/en',
		name: 'm_academic_activity_en',
		meta: {
			title: '学术活动'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/laboratory/academic_activity_list')
	}
];